import { Component, Injectable } from '@angular/core';
import { NgRedux } from '@angular-redux/store';
import { VehicleActions } from './vehicle-actions';
import { DispatcherModule } from '../dispatcher.module';
import { AppState } from '../state.model';
import { Vehicle } from '../../admin/models/vehicles/vehicle';

@Injectable({
  providedIn: DispatcherModule
})
export class VehicleDispatcher {
  constructor(
    private ngRedux: NgRedux<AppState>
  ) { }
  /**
  * setVehicleDetails Store the vehicleDetails
  * @param vehicleDetails vehicleDetails  from the vehicle payload
  **/
  setVehicles(vehicles: Array<any>) {
    this.ngRedux.dispatch(VehicleActions.setVehicles(vehicles));
  }
  /**
   * resetVehicleStore reset the store
   **/
  resetVehicleStore() {
    this.ngRedux.dispatch(VehicleActions.resetVehicleStore());
  }
    /**
  * @function setRemoteDetails Store the remote details
  * @return {void}
  **/
     setRemoteDetails(remoteDetails: object): void {
      this.ngRedux.dispatch(VehicleActions.setRemoteDetails(remoteDetails));
    }
}
